import { PolicyType } from '@/modules/api/openapi/models/PolicyType'

export enum ScheduleTypeEnum {
  WEEKLY_REPEATING = 'weekly_repeating',
  MONTHLY_REPEATING = 'monthly_repeating',
  YEARLY_REPEATING = 'yearly_repeating',
  SPECIFIC_DATETIMES = 'specific_datetimes',
  MONTHLY_OCCURRENCE_OF_DOW = 'monthly_occurrence_of_dow',
  NAMED_SCHEDULE = 'named_schedule',
}

export const SCHEDULE_TYPES = Object.values(ScheduleTypeEnum)

export const policyTypes = Object.values(PolicyType)

export const modalStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  minWidth: 600,
}

export const RECORDS_PER_PAGE = 10

export const POLICY_TYPE_COLOR_ORDER = [
  'no_stopping',
  'no_parking',
  'no_unloading',
  'no_loading',
  'loading',
  'unloading',
  'parking',
  'stopping',
  'travel',
  'no_travel',
]

export const DEBOUNCE_SEARCH_DELAY = 500
